/**
 * @author      tae@zumper.com (Tae Yoon)
 * @copyright   Copyright (c) 2019, Zumper
 * @description Messaging Modal Reducer
 */

import { TOUR } from '@zcode/nr/es/shared/constants/message'
import type { MessageModal } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import type * as actions from '../../actions/messageModal'
import { NEXT_STEP, PREVIOUS_STEP, RECEIVE_DATA } from '../../constants/messageModal'
import type { ActionTypes } from '../../types'
import { messagingModalReducer } from './messagingModalReducer'
import { metaReducer } from './metaReducer'

function isTwoStepMessageModalData({
  equalCTAIntent,
  hasInstantTourAvailability,
  isMobile,
  showDatePicker,
}: actions.ReceivedMessageData & { showDatePicker?: boolean }) {
  return (
    equalCTAIntent === TOUR &&
    isMobile &&
    // `satisfies boolean` because `undefined` would indicate that we're not sure whether it
    // has instant tour availability or not, and we need to be sure
    ((hasInstantTourAvailability satisfies boolean) || showDatePicker)
  )
}

export const messageReducer = combineReducers<MessageModal, ActionTypes>({
  data: messagingModalReducer,
  meta: metaReducer,
  step: handleActions<MessageModal['step'], ActionTypes>(
    {
      [PREVIOUS_STEP]: (state) => (state === 2 ? 1 : state),
      [NEXT_STEP]: (state) => (state === 1 ? 2 : state),
      [RECEIVE_DATA]: (state, { payload }) => {
        return isTwoStepMessageModalData(payload) ? 1 : null
      },
    },
    null
  ),
})
